/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["түнгі", "түскі", "таңғы", "түстен кейінгі", "кешкі", "түнгі"], ["түн жарымы", "түскі", "таңғы", "түстен кейінгі", "кешкі", "түнгі"], u], [["түн жарымы", "талтүс", "таң", "түстен кейін", "кеш", "түн"], u, u], ["00:00", "12:00", ["06:00", "12:00"], ["12:00", "18:00"], ["18:00", "21:00"], ["21:00", "06:00"]]];
